// Page-level header: title + optional subtitle + actions slot on the right.
// Lives at the top of every authenticated page for consistent typography.

export default function PageHeader({ title, subtitle, actions, icon }) {
  return (
    <div className="flex flex-col gap-3 mb-6 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex items-start gap-3">
        {icon ? (
          <span className="hidden sm:flex h-10 w-10 items-center justify-center rounded-xl bg-brand-50 text-brand-500 text-xl">
            {icon}
          </span>
        ) : null}
        <div>
          <h1 className="text-2xl font-semibold text-ink-900 leading-tight m-0">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm text-ink-500 mt-1 mb-0 max-w-2xl">
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
      {actions ? (
        <div className="flex items-center gap-2 flex-wrap">{actions}</div>
      ) : null}
    </div>
  );
}
